import { useState, useContext, useEffect } from 'react';
import { CountryContext } from '../../Context/Country/context';
import { DonationContext } from '../../Context/Donation';
import { DiseaseContext } from '../../Context/Disease';
import { fetchCountryDataAction } from '../../Context/Disease/action';

import { fetchCountryVaccinations } from '../../Context/Country/action';
import Map from "./Map1";

import DataCard from "./DataCard";
import AfricaDataCard from "./AfricaDataCard";
import { useMediaQuery } from 'react-responsive';
import './dv.css';

const DataVisualization = () => {
  // const { donationState, } = useContext(
  //   DonationContext
  // );


  const { countryState, dispatch: countryDispatch  } = useContext(
    CountryContext
  );

  const { diseaseState, dispatch: diseaseDispatch } = useContext(
    DiseaseContext
  );

  const { donationState } = useContext(DonationContext);



  const [activeCountry, setActiveCountry] = useState(
    countryState?.countryNameMap?.[countryState?.usersCountry?.country_name?.toLowerCase()] || {}
  );

  useEffect(() => {
    setActiveCountry(countryState?.countryNameMap?.[countryState?.usersCountry?.country_name?.toLowerCase()] || {})
  },[countryState?.usersCountry, countryState?.countryNameMap])


  useEffect(() => {
    diseaseDispatch(fetchCountryDataAction);
  }, [diseaseDispatch]);

  const selectCountryHandler = (e) => {
    const { value } = e.target;
    setActiveCountry(() => {
      const country = countryState?.countryMap?.[value];
      return country;
    });
  };

  useEffect(() => {
    if (activeCountry?.content?.id) {
      countryDispatch(
        fetchCountryVaccinations({ country: activeCountry?.name })
      );
    }
  }, [activeCountry?.content?.id, activeCountry?.name, countryDispatch]);


  const countrySelect = countryState?.countries?.map((country) => ({
    displayedValue: country?.name,
    value: country?.content?.id,
  }));


  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const mapClickHandler = (e) => {
    e.stopPropagation();
    const { id } = e.target;
    const country = countryState?.countryNameMap?.[id.toLowerCase()];
    if (country) {
      setActiveCountry(country);
    }
  };

  console.log()

  return (
    <div className="font-poppins relative  md:flex items-center overflow-hidden dv__wrapper slg:bg-moon">
      <div className="w-full flex justify-center flex-col bg-moon h-auto relative">
        {!isMobile && (
          <div className=" w-full flex justify-center slg:absolute africanDataCard slg:w-264">
            <div className="px-8 pt-7 w-full slg:p-0">
              <AfricaDataCard />
            </div>
          </div>
        )}
        <Map activeCountry={activeCountry} onClick={mapClickHandler} />
        {!isMobile && (
          <div className=" dataCard slg:absolute slg:w-276 w-full flex justify-center pb-8">
            <div className="px-8 w-full slg:p-0 slg:py-8 slg:bg-white slg:rounded">
              <DataCard
                fetchingCountrySummary={countryState?.fetchingDonationSummary}
                countryDonationSummary={donationState?.countrySummary?.[activeCountry?.name?.toLowerCase()]}
                countryDiseaseMap={diseaseState?.countryDiseaseMap}
                selectCountryHandler={selectCountryHandler}
                countrySelect={countrySelect}
                activeCountry={activeCountry}
                vaccinations={countryState?.countryVaccinations?.[activeCountry?.name?.toLowerCase()]}
                fetchingVaccinations={countryState?.fetchingVaccinations}
              />
            </div>
          </div>
        )}
      </div>
      {isMobile && (
        <>
          <DataCard
              fetchingCountrySummary={countryState?.fetchingDonationSummary}
              countryDonationSummary={donationState?.countrySummary?.[activeCountry?.name?.toLowerCase()]}
              countryDiseaseMap={diseaseState?.countryDiseaseMap}
              selectCountryHandler={selectCountryHandler}
              countrySelect={countrySelect}
              activeCountry={activeCountry}
              vaccinations={countryState?.countryVaccinations?.[activeCountry?.name?.toLowerCase()]}
              fetchingVaccinations={countryState?.fetchingVaccinations}
          />
          <AfricaDataCard />
        </>
      )}
    </div>
  );
};

export default DataVisualization;
